export default __webpack_public_path__ + "static/media/crc-hold-trx.38be1d7f.svg";